import { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { DiscoverProducts } from './DiscoverProducts'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FDF8F3]">
      <Header />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        {children}
      </main>
      <DiscoverProducts />
      <Footer />
    </div>
  )
}
